import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import constants from 'Constants';
import AccountStore from 'stores/Model/Account/AccountStore';
import OrganizationStore from 'stores/Model/Organization/OrganizationStore';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class UserStore {

  @setter @observable id;
  @setter @observable email;
  @setter @observable name;
  @setter @observable organization;

  @setter @observable isStaff;
  @setter @observable isSuperuser;
  @setter @observable isActive;
  @setter @observable isVerified;
  @setter @observable isOwner;

  @setter @observable missingPassword;
  @setter @observable timezone;
  @setter @observable currency;
  @setter @observable defaultAccount;
  @setter @observable defaultProduct;

  @setter @observable numMemberships;

  static create(data={}) {
    const instance = new UserStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "email": "",
      "name": "",
      "organization": new OrganizationStore(),

      "isStaff": false,
      "isSuperuser": false,
      "isActive": false,
      "isVerified": false,
      "isOwner": false,

      "missingPassword": false,
      "timezone": "",
      "currency": "",
      "defaultAccount": new AccountStore(),
      "defaultProduct": "",

      "numMemberships": 0,
    };
  }

  constructor(defaults=UserStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=UserStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "email"},
      {"field": "name"},
      {"field": "organization", "accessor": "organization", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": OrganizationStore},

      {"field": "isStaff", "accessor": "is_staff"},
      {"field": "isSuperuser", "accessor": "is_superuser"},
      {"field": "isActive", "accessor": "is_active"},
      {"field": "isVerified", "accessor": "is_verified"},
      {"field": "isOwner", "accessor": "is_owner"},

      {"field": "missingPassword", "accessor": "missing_password"},
      {"field": "timezone"},
      {"field": "currency"},
      {"field": "defaultAccount", "accessor": "default_account", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": AccountStore},
      {"field": "defaultProduct", "accessor": "default_product"},

      {"field": "numMemberships", "accessor": "num_memberships"},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get canLoginas() {
    const organization = this.organization;
    if (organization.isSuspended) return false;
    if (!this.isActive) return false;
    if (!this.isVerified) return false;
    if (this.isStaff) return false;
    return true;
  }
}


export default UserStore;

